import axios from 'axios';
import { getApiUrl } from '../helpers/clientConfig';

const apiClient = axios.create({
    baseURL: getApiUrl(),
    withCredentials: true,
});

apiClient.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response.status === 401) {
            window.location.href = '/sign-in';
        } else {
            return Promise.reject(error);
        }
    }
);

export default apiClient;
